import { Controller } from "@hotwired/stimulus"
import { validateCsvFile } from "../scripts/validate_csv"

export default class extends Controller {
  static targets = [ "formatSelect", "fileInput", "messageContainer", "submitButton", "form", "modal", "seasonField" ]

  connect() {
    // console.log("hello from import schedule controller");
    // console.log(this.formatSelectTarget);
    // console.log(this.fileInputTarget);
    // console.log(this.messageContainerTarget);

    // Team Settings → Schedule season rows pass their season, so the import is saved to that season.
    if (this.hasModalTarget && this.hasSeasonFieldTarget) {
      this.modalTarget.addEventListener('show.bs.modal', event => {
        const button = event.relatedTarget;
        const seasonId = button && button.dataset.importSeasonId;

        if (seasonId) {
          this.seasonFieldTarget.value = seasonId;
        }
      });
    }
  }

  async checkFileType(e) {
    e.preventDefault();

    // default to valid
    this.messageContainerTarget.textContent = '';
    this.submitButtonTarget.disabled = false;
    this.fileInputTarget.classList.remove('is-invalid');

    const file = this.fileInputTarget.files[0];

    if (!file) {
      // if no file selected, no issues yet
      return;
    }

    const fileType = file.type;
    const allowedTypes = ['text/calendar', 'text/csv', 'application/rss+xml'];
    if (!allowedTypes.includes(fileType)) {
      this.messageContainerTarget.textContent = 'Please select a valid file type.';
      this.fileInputTarget.classList.add('is-invalid');
      this.submitButtonTarget.disabled = true;
      return;
    }

    const fileTypeSelection = this.formatSelectTarget.value;
    if (fileTypeSelection == 'ical' && fileType != 'text/calendar') {
      this.messageContainerTarget.textContent = 'Please select a valid iCal file.';
      this.fileInputTarget.classList.add('is-invalid');
      this.submitButtonTarget.disabled = true;
      return;
    }

    if ( (fileTypeSelection == 'sidearm_csv' || fileTypeSelection == 'csv') && fileType != 'text/csv') {
      this.messageContainerTarget.textContent = 'Please select a valid CSV file.';
      this.fileInputTarget.classList.add('is-invalid');
      this.submitButtonTarget.disabled = true;
      return;
    }

    if (fileTypeSelection == 'presto_rss' && fileType != 'application/rss+xml') {
      this.messageContainerTarget.textContent = 'Please select a valid RSS file.';
      this.fileInputTarget.classList.add('is-invalid');
      this.submitButtonTarget.disabled = true;
      return;
    }

    if (fileTypeSelection == 'sidearm_csv' || fileTypeSelection == 'csv') {
      this.submitButtonTarget.disabled = true;
      const result = await validateCsvFile(file);
      if (!result.valid) {
        this.messageContainerTarget.textContent = result.message;
        this.fileInputTarget.classList.add('is-invalid');
        this.submitButtonTarget.disabled = true;
        return;
      }
      this.submitButtonTarget.disabled = false;
    }

  }

}
